import React from "react"
import { Field } from "formik"

type Props = {
    name: string;
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
}

export const CheckBox: React.FC<Props> = (props: Props) => {
    return (
        <div className={`checkbox-input ${props.className ?? ""} ${props.disabled ? "checkbox-disabled" : ""}`}>
            <Field type="checkbox" name={props.name} id={props.name} />
            <label htmlFor={props.name}>
                {props.children}
            </label>
        </div>

    );
};